import { Typography } from '@mui/material'
import { useHistory } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { actions } from '../../DivergenceDemandsState'
import { DivergenceDemandsState } from '../../DivergenceDemandsTypes'
import ArrowBackIosNewRoundedIcon from '@mui/icons-material/ArrowBackIosNewRounded'
import * as S from './Header.styles'

interface HeaderProps {
  title: string
  goBackRoute?: string
  propertyToClear?: keyof DivergenceDemandsState | (keyof DivergenceDemandsState)[]
  hasBackButton?: boolean
}

const Header: React.FC<HeaderProps> = ({
  title, goBackRoute, propertyToClear, hasBackButton = true,
}): JSX.Element => {
  const history = useHistory()
  const dispatch = useDispatch()

  const goBack = () => {
    if (propertyToClear) dispatch(actions.clearProperty(propertyToClear))
    if (goBackRoute) history.push(goBackRoute)
  }

  return (
    <S.Container>
      <Typography>{title}</Typography>
      {
        hasBackButton && (
          <ArrowBackIosNewRoundedIcon
            onClick={goBack}
            sx={{ position: 'absolute', right: '10px', cursor: 'pointer' }}
            data-testid='arrow-back-icon'
          />
        )
      }
    </S.Container>
  )
}

export default Header
